export default "<div>\n    <div data-bind=\"component: { name: 'statements-list'}\"></div>\n</div>";